module.exports = __webpack_public_path__ + "img/cadena.a1b4c7a3.svg";